import { render, staticRenderFns } from "./AddSQL22.vue?vue&type=template&id=048ec1a3&scoped=true&"
import script from "./AddSQL22.vue?vue&type=script&lang=js&"
export * from "./AddSQL22.vue?vue&type=script&lang=js&"
import style0 from "./AddSQL22.vue?vue&type=style&index=0&id=048ec1a3&prod&scoped=true&lang=css&"
import style1 from "./AddSQL22.vue?vue&type=style&index=1&id=048ec1a3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ec1a3",
  null
  
)

export default component.exports